"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeToJSON = exports.EventTypeFromJSONTyped = exports.EventTypeFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function EventTypeFromJSON(json) {
    return EventTypeFromJSONTyped(json, false);
}
exports.EventTypeFromJSON = EventTypeFromJSON;
function EventTypeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'isState': !(0, runtime_1.exists)(json, 'isState') ? undefined : json['isState'],
        'gameIds': !(0, runtime_1.exists)(json, 'gameIds') ? undefined : json['gameIds'],
        'fields': ((0, runtime_1.mapValues)(json['fields'], _1.FieldConfigFromJSON)),
    };
}
exports.EventTypeFromJSONTyped = EventTypeFromJSONTyped;
function EventTypeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'name': value.name,
        'isState': value.isState,
        'gameIds': value.gameIds,
        'fields': ((0, runtime_1.mapValues)(value.fields, _1.FieldConfigToJSON)),
    };
}
exports.EventTypeToJSON = EventTypeToJSON;
